import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/globals.css'
import 'react-day-picker/style.css'
import App from './App.tsx'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { PostHogProvider } from 'posthog-js/react'

// Create a client with optimized settings for form-heavy applications
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Disable refetch on window focus to prevent form data loss
      // when users switch between browser tabs
      refetchOnWindowFocus: false,
      // Still allow refetch on reconnect for network-related issues
      refetchOnReconnect: true,
      // Keep default stale time (0) so data is considered stale immediately
      // but won't refetch unless explicitly triggered
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
      }}
    >
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </PostHogProvider>
  </StrictMode>,
)
